import {Controller} from "stimulus"

var delayTimer;
export default class extends Controller {

    static get targets() {
        return ['optionsWrapper', 'option', 'trigger', 'triggerText', 'value']
    }

    initialize() {
        this.index = 0;
    }

    connect() {
        console.log("dropdown controller");
        if (this.hasValueTarget) {
            this.triggerTarget.setAttribute('aria-expanded', 'false');
            this.optionsWrapperTarget.classList.remove('dropdown__option-wrapper--visible');
            this.triggerTextTarget.innerHTML = this.valueTarget.options[this.valueTarget.selectedIndex].text;
        }
    }

    toggle() {
        event.preventDefault();

        if (this.triggerTarget.getAttribute('aria-expanded') == "false") {
            this.open();
        } else {
            this.close(null);
        }
    }

    open() {
        this.triggerTarget.setAttribute('aria-expanded', 'true');
        this.optionsWrapperTarget.classList.add('dropdown__option-wrapper--visible');
        this.focusOption(0);
    }

    close(event) {
        if (event
            && event.type == 'click'
            &&
            (this.optionTargets.includes(event.target)
                || this.triggerTarget.contains(event.target))) {
            event.preventDefault();
            return;
        }

        this.triggerTarget.setAttribute('aria-expanded', 'false');
        this.optionsWrapperTarget.classList.remove('dropdown__option-wrapper--visible');
    }

    getKey(event) {
        switch (event.code) {
            case 'ArrowDown':
                event.preventDefault();
                this.moveDown();
                break;
            case 'ArrowUp':
                event.preventDefault();
                this.moveUp();
                break;
            case 'Space':
                break;
            default:
                this.close(event);
        }
    }

    moveDown(increment = 1) {
        this.index = this.mod((this.index + increment), this.optionTargets.length);
        this.focusOption(this.index);
    }

    moveUp(increment = -1) {
        this.moveDown(increment);
    }

    // Allows for modulo of negative numbers, so the index can wrap back around.
    mod(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    focusOption(index) {
        this.optionTargets[index].focus();
    }

    chooseOption(choice) {
        const choiceValue = choice.target.innerText;
        console.log(choiceValue + " selected");
        const selectItem = choice.target.closest(".dropdown-wrapper").querySelector(".entry-type-select");

        if (!selectItem) {
            console.error('Could not find select element');
            return;
        }

        // Make sure we get the button element, not a child element
        const buttonElement = choice.target.closest('.dropdown__option');
        const dropdownValue = buttonElement ? buttonElement.dataset.selectDropDownValue : choice.target.dataset.selectDropDownValue;
        console.log("Setting select value to:", dropdownValue);
        console.log("Select element before:", selectItem.value, "selectedIndex:", selectItem.selectedIndex);

        selectItem.value = dropdownValue;
        Array.from(selectItem.querySelectorAll('option')).map(el => {
            el.removeAttribute("selected")
        });

        const optionToSelect = selectItem.querySelector('option[value="' + dropdownValue + '"]');
        console.log("Found option to select:", optionToSelect);
        if (optionToSelect) {
            optionToSelect.setAttribute('selected', 'selected');
        }

        console.log("Select element after:", selectItem.value, "selectedIndex:", selectItem.selectedIndex);

        selectItem.dispatchEvent(new Event('change'));
        this.triggerTarget.setAttribute('aria-expanded', 'false');
        this.optionsWrapperTarget.classList.remove('dropdown__option-wrapper--visible');
        this.triggerTextTarget.innerText = choiceValue;
    }
}
